import { InformativeBanner } from 'app/src/features/Catalog/components/InformativeBanner'
import type { CampaignInfo } from 'app/src/model'
import { membershipApi } from 'app/src/services/welfareportal'
import { TimerWidget } from 'app/src/shared/components'
import { useWebAppContext } from 'app/src/shared/hooks'
import type { ReactElement } from 'react'

export function InformativeBannerWithTimerSection(): ReactElement {
  const context = useWebAppContext()
  const phaseAndDeadline: CampaignInfo = membershipApi.getPhaseAndDeadline(context.userInfo.welfareCampaign)

  return (
    <div className='grid auto-rows-min gap-4 sm:grid-rows-1 lg:grid-cols-12 lg:grid-rows-1'>
      <div className={phaseAndDeadline.deadline ? 'col-span-12 lg:col-span-7' : 'col-span-12'}>
        <InformativeBanner />
      </div>
      {phaseAndDeadline.deadline && (
        <div className='col-span-12 lg:col-span-5'>
          <TimerWidget />
        </div>
      )}
    </div>
  )
}
